import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-521c1aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "cell history correct integral" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expression_cell = _resolveComponent("expression-cell")!
  const _directive_katex = _resolveDirective("katex")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createTextVNode("\\( \\int \\)")
    ])), [
      [_directive_katex, void 0, "auto"]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressions[_ctx.rowIndex], (_, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        _createVNode(_component_expression_cell, {
          "row-index": _ctx.rowIndex,
          "column-index": i,
          "is-input": _ctx.isInput,
          "is-history": _ctx.isHistory
        }, null, 8, ["row-index", "column-index", "is-input", "is-history"])
      ]))
    }), 128))
  ]))
}